import { type IExperienceDataProviderFactory } from '../embed-strategies/direct/experience-adapter/direct/data-provider-factory'

export const DIServices = {
  ExperienceDataProviderFactory: 'ExperienceDataProviderFactory'
} as const

export interface DIServiceMap {
  [DIServices.ExperienceDataProviderFactory]: IExperienceDataProviderFactory
}

/**
 * Allows to register/override DI services.
 * - {@link DIServices.ExperienceDataProviderFactory} - {@link IExperienceDataProviderFactory}: A factory to create an instance of {@link IExperienceDataProvider}.
 * Used only if `strategy` is 'direct-iframeless'. `DefaultExperienceDataProviderFactory` is used by default.
 */
export class DIServiceContainer {
  private readonly _registry: Map<keyof DIServiceMap, any>
  constructor () {
    this._registry = new Map()
  }

  register<K extends keyof DIServiceMap>(name: K, module: DIServiceMap[K]) {
    this._registry.set(name, module)
  }

  get<K extends keyof DIServiceMap>(name: K): DIServiceMap[K] | undefined {
    return this._registry.get(name)
  }

  has<K extends keyof DIServiceMap>(name: K): boolean {
    return this._registry.has(name)
  }

  unregister<K extends keyof DIServiceMap>(name: K): boolean {
    return this._registry.delete(name)
  }

  clear () {
    this._registry.clear()
  }
}
